var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#F0FFE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2837 30.3435C87.8556 32.4331 88.2465 36.2119 86.1569 38.7837L53.6569 78.7837C52.6512 80.0215 51.194 80.808 49.6074 80.9694C48.0207 81.1308 46.4351 80.6539 45.2008 79.6439L23.2008 61.6439C20.6361 59.5456 20.2581 55.7654 22.3564 53.2008C24.4548 50.6361 28.2349 50.2581 30.7996 52.3564L48.14 66.544L76.8435 31.2166C78.9331 28.6448 82.7119 28.2539 85.2837 30.3435Z",
    fill: "url(#paint0_linear_1_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7",
    x1: 49.5002,
    y1: 47.0002,
    x2: 48.5002,
    y2: 67.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04649B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCheck);
export default __webpack_public_path__ + "static/media/imgCheck.80712e32cd281c9671fad14ca3eea79f.svg";
export { ForwardRef as ReactComponent };